var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialsInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2419",
    "data-name": "Group 2419",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50.001,
    viewBox: "0 0 50 50.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_684",
    "data-name": "Rectangle 684",
    width: 50,
    height: 50.001,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2418",
    "data-name": "Group 2418",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M25,0c-6.79,0-7.642.03-10.308.151A18.346,18.346,0,0,0,8.626,1.313,12.242,12.242,0,0,0,4.2,4.2,12.273,12.273,0,0,0,1.312,8.624,18.262,18.262,0,0,0,.151,14.691C.031,17.358,0,18.211,0,25s.03,7.639.151,10.306a18.373,18.373,0,0,0,1.161,6.068A12.25,12.25,0,0,0,4.2,45.8a12.242,12.242,0,0,0,4.427,2.885,18.362,18.362,0,0,0,6.069,1.161C17.359,49.971,18.21,50,25,50s7.64-.03,10.306-.151a18.373,18.373,0,0,0,6.071-1.161,12.809,12.809,0,0,0,7.311-7.314,18.531,18.531,0,0,0,1.161-6.068C49.969,32.64,50,31.79,50,25s-.031-7.642-.151-10.308a18.522,18.522,0,0,0-1.161-6.068A12.27,12.27,0,0,0,45.8,4.2a12.218,12.218,0,0,0-4.427-2.883A18.4,18.4,0,0,0,35.3.151C32.635.03,31.786,0,24.995,0ZM22.76,4.505c.666,0,1.408,0,2.243,0,6.675,0,7.466.024,10.1.144a13.841,13.841,0,0,1,4.642.861,7.731,7.731,0,0,1,2.873,1.87,7.759,7.759,0,0,1,1.871,2.875,13.814,13.814,0,0,1,.861,4.641c.12,2.635.146,3.427.146,10.1s-.026,7.464-.146,10.1a13.827,13.827,0,0,1-.861,4.641,8.29,8.29,0,0,1-4.744,4.742,13.791,13.791,0,0,1-4.642.861c-2.635.12-3.427.146-10.1.146s-7.467-.026-10.1-.146a13.868,13.868,0,0,1-4.642-.862,7.743,7.743,0,0,1-2.875-1.87,7.749,7.749,0,0,1-1.871-2.873,13.814,13.814,0,0,1-.861-4.641c-.12-2.635-.144-3.427-.144-10.1s.024-7.464.144-10.1a13.841,13.841,0,0,1,.861-4.642A7.746,7.746,0,0,1,7.383,7.372,7.759,7.759,0,0,1,10.258,5.5,13.811,13.811,0,0,1,14.9,4.64c2.306-.1,3.2-.135,7.859-.141ZM38.347,8.656a3,3,0,1,0,3,3,3,3,0,0,0-3-3ZM25,12.162A12.837,12.837,0,1,0,37.839,25,12.839,12.839,0,0,0,25,12.162Zm0,4.505A8.333,8.333,0,1,1,16.669,25,8.333,8.333,0,0,1,25,16.667",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialsInstagram);
export default __webpack_public_path__ + "static/media/socials-instagram.33825d1dbc25ad9aab996d7f21ba4ec0.svg";
export { ForwardRef as ReactComponent };